import { Button, Col, Dropdown, List, Menu, Row } from 'antd';
import React, { useEffect, useState } from 'react';

import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import ProblemTypeItem from './ProblemTypeItem';
import { CopyOutlined, DownOutlined } from '@ant-design/icons';
import CopyRankingComponent from './CopyRankingComponent';
import CopyRankingToLocationsComponent from './CopyRankingToLocationsComponent';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

export default function ProblemTypesList({
	fetchSupplierPrivateNetworksForLocation,
	selected,
	fetchSupplierPrivateNetworkV2,
	updateRank,
	problemTypeIds,
}) {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(1);
	const [isCopying, setIsCopying] = useState(false);
	const [isCopyingToOthers, setIsCopyingToOthers] = useState(false);

	const problemTypeIdsKey = problemTypeIds.join(',');

	const getData = () => {
		setLoading(true);
		fetchSupplierPrivateNetworksForLocation(selected.id, {
			offset: 0,
			limit: 10,
			problemTypeIds: problemTypeIdsKey || undefined,
		}).then(({ data, count }) => {
			setLoading(false);
			setData(data);
			setTotal(count);
			setPage(1);
		});
	};
	useEffect(() => {
		if (selected.id) {
			getData();
		} else {
			setData([]);
			setTotal(0);
			setPage(1);
			setLoading(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected.id, problemTypeIdsKey, fetchSupplierPrivateNetworksForLocation]);

	return (
		<div className="h-full p-6" id="ProblemTypeListComponent">
			<CopyRankingComponent
				visible={isCopying}
				onCancel={() => setIsCopying(false)}
				selectedLocation={selected}
				problemTypeIds={problemTypeIds}
				onSuccess={() => {
					getData();
					setIsCopying(false);
				}}
			/>
			<CopyRankingToLocationsComponent
				visible={isCopyingToOthers}
				onCancel={() => setIsCopyingToOthers(false)}
				selectedLocation={selected}
				problemTypeIds={problemTypeIds}
				onSuccess={() => {
					getData();
					setIsCopyingToOthers(false);
				}}
			/>
			<Row className="mb-5 ">
				<Col span={12}>
					<div className="mb-5 text-2xl text-black">{selected.name}</div>
				</Col>

				<Col span={12}>
					<Row justify="end" wrap={false}>
						<AccessPermissionChecker name={PERMISSION_NAMES.EDIT_SUPPLIER_NETWORK_ASSOCIATION}>
							<Dropdown
								trigger={['hover']}
								overlay={
									<Menu>
										<Menu.Item key="copy-from" onClick={() => setIsCopying(true)}>
											Copy from another location
										</Menu.Item>
										<Menu.Item
											key="copy-to"
											disabled={!selected.id}
											onClick={() => setIsCopyingToOthers(true)}
										>
											Copy to other locations
										</Menu.Item>
									</Menu>
								}
							>
								<Button type="default" icon={<CopyOutlined translate="" />} size="large">
									Copy
									<DownOutlined translate="" className="ml-2" />
								</Button>
							</Dropdown>
						</AccessPermissionChecker>
					</Row>
				</Col>
			</Row>

			{(loading && <PageLoadingPlaceholder />) || (
				<List
					key={selected.id}
					pagination={{
						current: page,
						pageSize: 10,
						total,
						onChange: (current) => {
							setPage(current);
							setLoading(true);
							document.getElementById('ProblemTypeListComponent').scrollIntoView();
							fetchSupplierPrivateNetworksForLocation(selected.id, {
								offset: (current - 1) * 10,
								limit: 10,
								problemTypeIds: problemTypeIdsKey || undefined,
							}).then(({ data, count }) => {
								setLoading(false);
								setData(data);
								setTotal(count);
								document.getElementById('ProblemTypeListComponent').scrollIntoView();
							});
						},
						showSizeChanger: false,
					}}
					loading={loading}
					itemLayout="horizontal"
					dataSource={data}
					renderItem={(item: any, index) => (
						<ProblemTypeItem
							refreshData={getData}
							key={`${selected.id}_${item.problemTypeId}_${index}`}
							data={item}
							updateRank={updateRank}
							fetchSupplierPrivateNetworkV2={fetchSupplierPrivateNetworkV2}
							selectedLocation={selected}
						/>
					)}
				/>
			)}
		</div>
	);
}
